//#region IMPORTS
import { getOrderTypeColor } from "../../helpers/getOrderTypeColor";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  orderTypeName: string;
}
//#endregion

export default function OrderTypeBadge({ orderTypeName }: Props) {
  //#endregion RENDER
  return (
    <span
      className={classNames(
        getOrderTypeColor(orderTypeName).text,
        getOrderTypeColor(orderTypeName).ring,
        "inline-flex items-center gap-x-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset"
      )}
    >
      <svg
        className={classNames(
          getOrderTypeColor(orderTypeName).fill,
          "h-1.5 w-1.5"
        )}
        viewBox="0 0 6 6"
        aria-hidden="true"
      >
        <circle cx={3} cy={3} r={3} />
      </svg>
      {orderTypeName}
    </span>
  );
  //#endregion
}
